export const IMPORT_TYPES = {
  customers: {
    label: 'Customers',
    fields: [
      { key: 'name', label: 'Customer Name', required: true, aliases: ['name', 'customer', 'customer name', 'company', 'client'] },
      { key: 'site', label: 'Site Name', aliases: ['site', 'site name', 'location', 'facility', 'battery', 'plant'] },
      { key: 'lsd', label: 'LSD / Address', aliases: ['lsd', 'address', 'lsd/address', 'lsd / address', 'legal'] },
    ],
    example: 'name,site,lsd\nNorthgate Energy Ltd,Red Deer Battery,04-12-048-07W5\nNorthgate Energy Ltd,Drayton Valley Compressor Station,11-22-050-08W5\nAcme Oilfield,Main Yard,',
    hint: 'One row per site — repeat the customer name to give it several sites. Existing customers get the new sites merged in.',
  },
  vendors: {
    label: 'Vendors',
    fields: [
      { key: 'name', label: 'Vendor Name', required: true, aliases: ['name', 'vendor', 'vendor name', 'company', 'supplier'] },
      { key: 'category', label: 'Category', aliases: ['category', 'type', 'service', 'trade'] },
      { key: 'contact', label: 'Contact', aliases: ['contact', 'phone', 'email', 'contact info', 'website'] },
    ],
    example: 'name,category,contact\nPrecision Calibration Ltd,calibration,403-555-0100\nNorthern Crane Inspections,inspection,info@northerncrane.ca',
    hint: 'Vendors are matched by name; existing names are skipped.',
  },
  equipment: {
    label: 'Shop Equipment',
    fields: [
      { key: 'name', label: 'Name', required: true, aliases: ['name', 'equipment', 'equipment name', 'asset', 'description'] },
      { key: 'make', label: 'Make', aliases: ['make', 'manufacturer', 'mfr', 'brand'] },
      { key: 'model', label: 'Model', aliases: ['model', 'model #', 'model no'] },
      { key: 'serial_number', label: 'Serial #', aliases: ['serial_number', 'serial', 'serial #', 'serial no', 'sn', 's/n'] },
      { key: 'cost', label: 'Cost', aliases: ['cost', 'rate', 'price', 'cost per hour', 'hourly rate'] },
      { key: 'cost_type', label: 'Cost Type (per_hour | per_use)', aliases: ['cost_type', 'cost type', 'rate type', 'billing'] },
      { key: 'status', label: 'Status (available | in_use | maintenance)', aliases: ['status', 'state', 'condition'] },
      { key: 'purchase_date', label: 'Purchase Date (YYYY-MM-DD)', aliases: ['purchase_date', 'purchase date', 'purchased', 'acquired', 'date'] },
    ],
    example: 'name,make,model,serial,cost,cost_type,status,purchase_date\nDynamic Balancer,Schenck,HM20,SB-20441,85,per_hour,available,2022-04-15\nHydraulic Press 50T,Dake,50H,DK-8812,40,per_hour,available,',
    hint: 'Duplicates are detected by serial number (or by name when no serial is given).',
  },
};

// Auto-map CSV header cells to import fields.
export const autoMap = (kind, headers) => {
  const fields = IMPORT_TYPES[kind].fields;
  const used = new Set();
  return headers.map((h) => {
    const key = h.toLowerCase().trim();
    const f = fields.find((x) => !used.has(x.key) && (x.key === key || x.aliases.includes(key)));
    if (f) used.add(f.key);
    return f ? f.key : '';
  });
};

// Default positional mapping when no header row is present.
export const positionalMap = (kind, width) => IMPORT_TYPES[kind].fields.slice(0, width).map((f) => f.key);
